const OVERVIEW_ENDPOINTS = {
  GLOBAL_METRICS: (brandId: string): string =>
    `/brands/${brandId}/overview/global_metrics`,
  CHARTS: (brandId: string): string => `/brands/${brandId}/overview/charts`,
  SHARE: (brandId: string): string => `/brands/${brandId}/overview/share`,
  GLOBAL_INSIGHTS: (brandId: string): string =>
    `/brands/${brandId}/overview/global_insights`,
  BUDGETS: (brandId: string): string => `/brands/${brandId}/budgets`,
  OPTIMIZATION: (brandId: string): string =>
    `/brands/${brandId}/campaigns_optimization`,
  SPLIT_TESTS: (brandId: string): string => `/brands/${brandId}/split_tests`,
  SPLIT_TEST_DETAILS: (brandId: string, split_test_id: string): string =>
    `/brands/${brandId}/split_tests/${split_test_id}`,
  SPLIT_TEST_BUDGET_UPDATE: (brandId: string, split_test_id: string): string =>
    `/brands/${brandId}/split_tests/${split_test_id}/budgets`
};

export default OVERVIEW_ENDPOINTS;
